import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LayerSearchResult } from './map/layer/layer.type';

export interface SearchResults {
  sourceId: string;
  sourceName: string;
  /// If true, each result is appended to other results with the same `sourceId`.
  auxiliary?: boolean;
  results: SearchResult[];
}

/**
 * `sourceId` and `sourceName` are lifted into the individual `SearchResult`s primarily to make handling arrays of results easier.
 * Usually they're the same as the containing `SearchResults`' `sourceId` and `sourceName`.
 * For auxiliary results, `sourceId` identifies the "normal" search source to fold these results into.
 * If that source has no results of its own, `sourceName` from here may be used to fill the name in.
 */
export interface SearchResult extends LayerSearchResult {
  sourceId: string;
  sourceName: string;
}

/**
 * Service for all searches in REGO application. This service provides Observables for new search requests
 * and new search results. Other services contain actual searching logic because it makes no sense to create
 * one monolithic service which has knowledge of all possible datatypes.
 */
@Injectable()
export class SearchService {

  /**
   * search term
   */
  private searchTerm = new Subject<string>();
  /**
   * Observable for search term changes
   */
  public searchTermChanged$ = this.searchTerm.asObservable();

  /**
   * search results
   */
  private searchResult = new Subject<SearchResults>();
  /**
   * Observable for search result changes
   */
  public searchResultChanged$ = this.searchResult.asObservable();

  /**
   * Publish new search request to search providers
   */
  public search(searchTerm: string) {
    console.log('search for', searchTerm);
    this.searchTerm.next(searchTerm + '');
  }

  /**
   * Publish new search result to subscribers
   */
  public publishResult(result: SearchResults) {
    // console.log('search search publish', result);
    this.searchResult.next(result);
  }
}
